// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NGIi","option":"styles_option__1CdFe","selected":"styles_selected__omq-k"};